import { useState, useContext } from 'react';
import './App.css';
import { Routes, Route } from 'react-router';
import Stereo from './Stereo';
import VR from './VR';
import LoginPage from './Login';
import { ProtectedRoute, ProtectedRouteProps } from './firebase/firebaseSetup';
import { AuthContext } from './auth/AuthContext';

function App() {
  const reel = 'dc';
  const onLocatedLogin = () => {

  }
  const authContext = useContext(AuthContext);

  const defaultProtectedRouteProps = {
    isAuthenticated: !!authContext.user,
    redirect: (<LoginPage onLogin={onLocatedLogin} />),
  };
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Stereo reel={reel} />} />
        <Route path="/vr" element={<VR reel={reel} />} />
        <Route path="/neal-vr-1" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<VR reel={"neal1"} />} />} />
        <Route path="/neal-vr-2" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<VR reel={"neal2"} />} />} />
        <Route path="/neal-vr-3" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<VR reel={"neal3"} />} />} />
      </Routes>
    </div>
  );
}

export default App;
